const mockUser = 
    {
        login: "1Alliemack77",
        id: 67376682,
        node_id: "MDQ6VXNlcjY3Mzc2Njgy",
        avatar_url: "https://avatars.githubusercontent.com/u/67376682?v=4",
        gravatar_id: "",
        url: "https://api.github.com/users/Alliemack77",
        html_url: "https://github.com/Alliemack77",
        followers_url: "https://api.github.com/users/Alliemack77/followers",
        following_url: "https://api.github.com/users/Alliemack77/following{/other_user}",
        gists_url: "https://api.github.com/users/Alliemack77/gists{/gist_id}",
        starred_url: "https://api.github.com/users/Alliemack77/starred{/owner}{/repo}",
        subscriptions_url: "https://api.github.com/users/Alliemack77/subscriptions",
        organizations_url: "https://api.github.com/users/Alliemack77/orgs",
        repos_url: "https://api.github.com/users/Alliemack77/repos",
        events_url: "https://api.github.com/users/Alliemack77/events{/privacy}",
        received_events_url: "https://api.github.com/users/Alliemack77/received_events",
        type: "User",
        site_admin: false,
        name: "Allison Leggett",
        company: null,
        blog: "",
        location: null,
        email: null,
        hireable: null,
        bio: null,
        twitter_username: null,
        public_repos: 49,
        public_gists: 0,
        followers: 17,
        following: 13,
        created_at: "2020-06-24T13:32:26Z",
        updated_at: "2023-03-06T00:24:11Z"
    }

export default mockUser